import React from 'react'
import styled, { css } from 'styled-components'
import CollapsibleCardContainer from './CollapsibleFormCard'
import { responsive } from "../../common/styledHelpers"
import Question, {
  CategoryContainer,
  Heading,
  Option,
  OptionWrapper,
  ToolTip,
  SectionWrapper
} from './CardSubSection'
import { colors } from 'buoy-theme'
import { nDashPlaceholder } from './userDetailsUtilities'
// 4851-todo: update responsive helper

const SelectAllWrapper = styled(SectionWrapper)`
  ${responsive(
    "padding-left",
    "56px",
    "20px"
  )};
  flex-direction: row;
`

const InlineHeading = styled(Heading)`
  justify-self: flex-start;
  ${responsive(
    "margin",
    "0",
    "0 auto 0 0")};
`

const ResponseText = styled(Heading)`
  width: 100%;
  ${props => props.heading ? css`
  ` : css`
    padding-left: 16px;
    margin-bottom: 10px;
    color: ${colors.neutral};
  `};
`

const ResponseContainer = styled.div`
  ${responsive("width", "50%", "100%")};
  align-self: flex-end;
  margin-left: auto;
  display: flex;
  flex-direction: column;
`

const ReverseOption = styled(Option)`
  flex-direction: row-reverse;
  ${responsive(
    "margin",
    "0 8px",
    "0")};

  div {
    margin: 0 0 0 8px;
  }

  &:first-child {
    ${responsive(
      "margin-right",
      "9px",
      "-8px")};
    ${responsive(
      "margin-left",
      "-90px",
      "unset")};
  }

  &:last-child {
    ${responsive(
      "margin-right",
      "8px",
      "-6px"
    )}
  }
`

const SelectAll = ({
  onClick,
  selectAll,
  inputName,
}) => (
  <SelectAllWrapper inline>
    <InlineHeading>Select all</InlineHeading>
    <OptionWrapper inline subList>
      <ReverseOption
        inline={true}
        name={inputName}
        label='Yes'
        value='yes'
        labelledBy=''
        selected={selectAll === true}
        onClick={onClick(true)}
      />
      <ReverseOption
        inline={true}
        name={inputName}
        label='No'
        value='no'
        labelledBy=''
        selected={selectAll === false}
        onClick={onClick(false)}
      />
    </OptionWrapper>
  </SelectAllWrapper>
)

class Category extends React.Component {
  state = {
    selectAll: null,
  }

  componentDidMount = () => {
    this.setSelectAll()
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps !== this.props) {
      this.setSelectAll()
    }
  }
  
  setSelectAll = () => {
    const { questions } = this.props
    let selectAll = null
    
    if ( questions.every(q => q.answer && q.options[q.answer].text === 'Yes') ) {
      selectAll = true
    } else if ( questions.every(q => q.answer && q.options[q.answer].text === 'No')) {
      selectAll = false
    }
    this.setState({ selectAll: selectAll })
  }

  toggleSelectAll = value => () => {
    let { selectAll } = this.state
    let { questions } = this.props
    this.props.setEdited(true)
    
    if ( selectAll === null || selectAll !== value) {
      let selected = value ? 'Yes' : 'No'
      questions.forEach((q, i) => {
        Object.keys(q.options).forEach(k => {
          if (q.options[k].text === selected && (!q.answer || !q.answer.includes(q.options[k].token)) ) {
            this.props.setAnswer(this.props.category, q.options[k].token, i)
          }
        })
      })
    } else {
      questions.forEach((q, i) => {
        Object.keys(q.options).forEach(k => {
          if (q.answer !== null && q.answer.includes(q.options[k].token)) {
            this.props.setAnswer(this.props.category, q.options[k].token, i)
          }
        })
      })
    }
  }

  hasResponses = questions => {
    return !questions.every(q => !q.answer || q.length === 0 || q.options[q.answer].text === 'No')
  }

  render() {
    let { selectAll } = this.state
    let {
      last,
      tooltip,
      questions,
      header_text,
      isEditing,
      setAnswer,
      category,
      setEdited,
      renderResponse,
    } = this.props
    let hasResponses = this.hasResponses(questions)
    
    return (
      <CategoryContainer last={last} isEditing={isEditing}>
        <Heading isEditing={isEditing}>{header_text}</Heading>
        {isEditing ? (
          <React.Fragment>
            {tooltip && isEditing && <ToolTip message={tooltip} />}
            {questions && <SelectAll
              onClick={this.toggleSelectAll}
              selectAll={selectAll}
              inputName='Select all'
            />}
            {questions && questions.sort((a, b) => a.order > b.order).map((q, i) => (
            <Question
              key={q.text}
              question={q}
              questionIndex={i}
              expand={selectAll}
              isEditing={isEditing}
              setAnswer={setAnswer}
              category={category}
              setEdited={setEdited}
              last={i === questions.length - 1}
              toggleSelectAll={this.toggleSelectAll}
            />
            ))}
          </React.Fragment>
        ) : (
          <ResponseContainer>
            {hasResponses ? (
              questions.sort((a, b) => a.order > b.order).map(q => {
                let response = renderResponse(q)
                if (response.length >= 0) {
                  return (
                    <React.Fragment key={q.text}>
                      <ResponseText heading={true}>{q.text}</ResponseText>
                      {response && <ResponseText>{response}</ResponseText>}
                    </React.Fragment>
                  )
                }
                return null
              })
            ) : (
              <ResponseText heading={true}>{nDashPlaceholder}</ResponseText>
            )}
          </ResponseContainer>
        )}
      </CategoryContainer>
    )
  }
}


class MedicalHistoryCard extends React.Component {
  state = {
    isEditing: false,
    error: null,
    loading: false,
    edited: false,
  }

  cancel = () => {
    this.props.cancelEditPredispositions(this.props.medicalHistoryCategory)
    this.props.cancelEditPredispositions(this.props.surgicalHistoryCategory)
    this.setState({
      isEditing: false,
      error: null,
      edited: false,
    })
    if (this.props.cancel) this.props.cancel()
  }

  edit = () => {
    this.props.editPredispositions(this.props.medicalHistoryCategory)
    this.props.editPredispositions(this.props.surgicalHistoryCategory)
    this.setState({
      isEditing: true,
      error: null,
      edited: false,
    })
  }

  setEdited = value => {
    if (value !== this.state.edited) this.setState({ edited: value })
  }

  save = () => {
    this.setState({ loading: true, error: null })
    return this.props
      .saveProfileAnswers(this.props.selected.id, [
        this.props.surgicalHistoryCategory,
        this.props.medicalHistoryCategory,
      ])
      .then(() => this.setState({
        isEditing: false,
        loading: false,
        edited: false,
      }))
      .catch(() => this.setState({
        error: 'Something went wrong. Please try again.',
        loading: false,
      })
      )
  }

  renderResponse = question => {
    if (question.answer && question.options[question.answer].text === 'Yes') {
      let response = []
      const answer = Array.isArray(question.answer)
        ? question.answer
        : [question.answer]
      answer.forEach(a => {
        question.options[a].extensions.forEach(e => {
          if (e.answer) {
            e.answer = Array.isArray(e.answer) ? e.answer : [e.answer]
            e.answer.forEach(a => {
              response.push(e.options[a].text)
            })
          }
        })
      })
      return response.join(", ")
    } 
    return false
  }

  isDisabled = () => {
    const questions = [...this.props.medicalHistoryQuestions.questions, ...this.props.surgicalHistoryQuestions.questions]
    
    const none = questions.every(q => !q.answer || q.answer.length === 0)
    const some = questions.every(
      q =>
        (q.answer && q.options[q.answer].extensions.every(e => e.answer && e.answer.length > 0)) ||
        (!q.answer || q.answer.length === 0)
    )

    return none ? true : !some
  }

  render() {
    let { isEditing, loading, edited } = this.state
    const disabled = loading || this.isDisabled()
    let {
      setAnswer,
      selected,
      medicalHistoryQuestions,
      surgicalHistoryQuestions,
      medicalHistoryCategory,
      surgicalHistoryCategory,
    } = this.props
    return (
      <CollapsibleCardContainer
        {...this.state}
        {...this.props}
        edit={this.edit}
        dirty={isEditing}
        cancel={this.cancel}
        save={this.save}
        showCompletion={true}
        disabled={!edited || disabled}
      >
        <Category
          setAnswer={setAnswer}
          selected={selected}
          setEdited={this.setEdited}
          category={medicalHistoryCategory}
          isEditing={isEditing}
          renderResponse={this.renderResponse}
          {...medicalHistoryQuestions}
        />
        <Category
          setAnswer={setAnswer}
          selected={selected}
          setEdited={this.setEdited}
          category={surgicalHistoryCategory}
          isEditing={isEditing}
          renderResponse={this.renderResponse}
          last={true}
          {...surgicalHistoryQuestions}
        />
      </CollapsibleCardContainer>
    )
  }
}

export { MedicalHistoryCard as default }



// WEBPACK FOOTER //
// ./assets/account/components/MedicalHistoryProfileCard.js